import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BasketReturnModel } from 'src/business/services/client.generated';
import { ImageUtil } from 'src/layout/media/image.util';
import { BasketService } from '../../services/basket.service';

@Component({
    selector: 'app-basket',
    templateUrl: './basket.component.html',
    styleUrls: ['./basket.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketComponent {
    basket$: Observable<BasketReturnModel>;
    constructor(
        private basketService: BasketService,
    ) {
        this.basket$ = basketService.basket$;
    }
    get() {
        this.basketService.get();
    }
}
